<template>
  <v-row v-if="!isAdministrator">
    <v-col cols="12">
      <Settings :organizationUsers="organizationUsers" />
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col cols="12">
      <AdminSettings :organizationsSettings="organizationsSettings" />
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Settings from "@/components/Settings/Settings";
import AdminSettings from "@/components/Settings/AdminSettings";

export default {
  components: {
    Settings,
    AdminSettings,
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
      organizationUsers: (state) => state.organizations.organizationUsers,
      organizationsSettings: (state) =>
        state.organizations.organizationsSettings,
    }),
    isAdministrator: function () {
      return this.user.userRoles != null
        ? this.user.userRoles.includes("Administrator")
        : null;
    },
  },
  methods: {
    ...mapActions({
      getUser: "users/GET_USER",
      getOrganizationUsers: "organizations/GET_ORGANIZATION_USERS",
      getOrganizationsSettings: "organizations/GET_ORGANIZATIONS_SETTINGS",
    }),
  },
  mounted: async function () {
    await this.getUser(this.user.userId);

    if (this.isAdministrator) {
      await this.getOrganizationsSettings();
    } else {
      await this.getOrganizationUsers();
    }
  },
};
</script>
